import React, { Fragment, useEffect, useState } from 'react';
import { Box, ClickAwayListener, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { Enums } from '../../../config/enums';
import { HOME } from '../../../config/app-url';
import { OKRButton } from '../../Common/OKRButton';
import { BottomArrowIcon } from '../../../config/svg/CommonSvgIcon';
import WelcomeImage from '../../../images/decline.svg';
import '../../../styles/pages/people-progress/people-progress.scss';
import '../../../styles/pages/admin/bulkUserEdit.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
	getDrApiDetails,
	getOkrMasterData,
	setPeoplefiltersList,
	setPeopleSelectedOption,
} from '../../../action/myGoal';
import { TaskSearch } from '../../GlobalTask/TaskList/TaskSearch';
import { AnimatedIcon } from '../../Common/AnimatedIcon';
import { KpiPeopleProgressCard } from './KpiPeopleProgressCard';
import { KpiProgressSorting } from './KpiProgressSorting';
import { getKpiDrApiDetails } from '../../../action/MyKpis';
import { getCycleDefaultSelection, getUserDetails } from '../../../config/utils';
import { getLocalStorageItem } from '../../../services/StorageService';

export const KpiPeopleProgress: React.FC<any> = (props) => {
	const { t, pastCycles } = props;
	const userDetail: any = getUserDetails();
	const cycleId = getLocalStorageItem('cycleId2') ? parseInt(getLocalStorageItem('cycleId2') || '0') : 0;

	const [drUserData, setDrUserData] = useState<any>([]);
	const [loadData, setLoadData] = useState<any>([]);

	const [filterData, setFilterData] = useState<any>({ pageIndex: 1, pageSize: 99999, totalPages: 1 });
	const [pageIndex, setPageIndex] = useState(1);
	const [searchText, setSearchText] = useState<string>('');

	const [showDrawer, setShowDrawer] = useState<boolean>(false);
	const [selectedUser, setSelectedUser] = useState<any>(null);
	const [open, setOpen] = React.useState<Boolean>(false);
	const [selectedOption, setSelectedOption] = useState(0);
	const [openPeopleProgress, setOpenPeopleProgress] = useState<Boolean>(false);
	const [teamToFilter, setTeamToFilter] = useState<any[]>([]);

	const dispatch = useDispatch();
	const [directReportResultStatus, setDirectReportResultStatus] = React.useState<Boolean>(false);
	const [searchTextArray, setSearchTextArray] = useState<any>('');
	const staticFilterObj = {
		sortingText: 'aToZ',
		order: '',
	};
	const { okrMasterData, peopleProgressFilters, peopleSelectedOption } = useSelector((state: any) => state?.okrReducer);
	const [showLoadMore, setShowLoadMore] = useState(false);
	const [listLoading, setListLoading] = useState(false);
	const [filterDetails, setFilterDetails] = useState<any>(staticFilterObj);
	const [selectedUsers, setSelectedUsers] = useState<any>({});
	useEffect(() => {
		setShowLoadMore(false);
		dispatch(getOkrMasterData());
	}, []);
	useEffect(() => {
		setSelectedOption(peopleSelectedOption);
	}, [peopleSelectedOption]);
	/*useEffect(() => {
	}, [searchText, pageIndex, filterDetails, teamToFilter, props.userSelectedCycle?.organisationCycleId]);*/
	useEffect(() => {
		getDrDetails();
	}, [cycleId]);

	const getDrDetails = async () => {
		try {
			//setLoader(true);
			setListLoading(true);
			let requestParam: any = {
				cycleId: cycleId,
				employeeId: userDetail.employeeId,
				pageIndex: 1,
				pageSize: 999,
				sortingType: 2,
				finder: [],
			};
			const response: any = await dispatch(getKpiDrApiDetails(requestParam));
			if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
				setDirectReportResultStatus(true);
				if (pageIndex !== 1) {
					let currentRecords = [...drUserData, ...response?.data.entity.kpiPeopleProgress];
					setDrUserData(currentRecords);
				} else {
					setDrUserData(response?.data.entity.kpiPeopleProgress);
				}

				/*dispatch(
					setPeoplefiltersList({
						...peopleProgressFilters,
						filterData: {
							pageIndex: response?.data.entity.pageIndex,
							pageSize: response?.data.entity.pageSize,
							totalPages: response?.data.entity.totalPages,
							totalRecords: response?.data.entity.totalRecords,
						},
					})
				);*/
				setFilterData({
					pageIndex: response?.data.entity.pageIndex,
					pageSize: response?.data.entity.pageSize,
					totalPages: response?.data.entity.totalPages,
					totalRecords: response?.data.entity.totalRecords,
				});
				if (pageIndex < response?.data?.entity.totalPages) {
					setShowLoadMore(true);
				} else {
					setShowLoadMore(false);
				}
				setListLoading(false);
				//setLoader(false);
			} else {
				setDirectReportResultStatus(false);
				setListLoading(false);
				//setLoader(false);
			}
		} catch (error) {}
	};

	const handleGiveFeedBack = () => {
		setShowDrawer(!showDrawer);
	};

	const handleOnClickPerformanceSnapshot = (e: any, data: any) => {
		setSelectedUser(data);
	};
	const handleDrawerClose = (e: any, type: any) => {
		setSelectedUser(null);
	};
	const handleClick = () => {
		setOpen((prev: Boolean) => !prev);
	};
	const handleClickAway = () => {
		setOpen(false);
	};
	const handleOptionClick = (option: any) => {
		setSelectedOption(option);
		dispatch(setPeopleSelectedOption(option));
		if (option === 0) {
			//setTeamToFilter([]);
			dispatch(setPeoplefiltersList({ ...peopleProgressFilters, teamToFilter: [] }));
		}
		setOpen(false);
	};
	const handleSearchText = (searchString = '') => {
		dispatch(setPeoplefiltersList({ ...peopleProgressFilters, searchText: searchString, pageIndex: 1 }));
	};
	const loadMore = () => {
		dispatch(setPeoplefiltersList({ ...peopleProgressFilters, pageIndex: peopleProgressFilters.pageIndex + 1 }));
	};
	const handleSortingFilterClick = (sortingText: string, order: string, id: any) => {
		/*setFilterDetails({
			sortingText: sortingText,
			order: order,
			id: id,
		});*/
		dispatch(
			setPeoplefiltersList({
				...peopleProgressFilters,
				filterDetails: {
					sortingText: sortingText,
					order: order,
					id: id,
				},
			})
		);
	};
	const handlePeopleProgressClose = (event: any, type: any) => {
		if (type !== 'save') {
			handleOptionClick(0);
		}
		setOpenPeopleProgress(false);
	};
	return (
		<Fragment>
			<Box className='okr-tabpanel-actions people-progress-actions'>
				<Typography variant='h2'>{t('directReportsLable')}</Typography>
				{(directReportResultStatus && drUserData && drUserData.length > 0) ||
				(peopleProgressFilters.searchText && peopleProgressFilters.searchText.length) ? (
					<Box className='pp-sort-search-area'>
						{' '}
						<KpiProgressSorting filterDetails={filterDetails} handleSortingFilterClick={handleSortingFilterClick} />
						<TaskSearch
							searchTextArray={searchTextArray}
							setSearchTextArray={setSearchTextArray}
							handleSearchText={handleSearchText}
						/>
					</Box>
				) : (
					<></>
				)}
			</Box>
			<Box className='people-progress-panel-area'>
				{/* Cards listing */}
				{listLoading ? (
					<Box className='loading-center-global'>
						<Typography>Loading...</Typography>
					</Box>
				) : directReportResultStatus && drUserData && drUserData.length > 0 ? (
					<Box className='people-progress-listing-area'>
						{drUserData.map((item: any, index: any) => (
							<>
								<KpiPeopleProgressCard
									handleGiveFeedBack={handleGiveFeedBack}
									panelUsed={HOME}
									{...props}
									data={item}
									userDetail={userDetail}
									t={t}
									cardId={`card-${index}`}
									handleOnClickPerformanceSnapshot={(e: any) => handleOnClickPerformanceSnapshot(e, item)}
								/>
							</>
						))}
					</Box>
				) : (
					<Box className='welcome-content'>
						<Box textAlign='center'>
							{props?.userSelectedCycle?.cycleStatus !== Enums.PAST_CYCLE_ID ? (
								<>
									<Typography variant='h2'>{t('noDirectReportTitle')}</Typography>
									<Typography>{t('noDirectReportTitle')}</Typography>
								</>
							) : (
								<>
									<Typography variant='h2'>{t('pastNoDirectReportTitle')}</Typography>
									<Typography>{t('pastNoDirectReportSubTitle')}</Typography>
								</>
							)}

							<AnimatedIcon className='' width='516' type='image/svg+xml' alt='WelcomeImage' imagePath={WelcomeImage} />
						</Box>
					</Box>
				)}
				{showLoadMore && (
					<Box className='alignCenter' display={'flex'} justifyContent={'center'}>
						<OKRButton id='load-more' className='btn-link' handleClick={loadMore} text={'Load More...'}></OKRButton>
					</Box>
				)}
			</Box>
		</Fragment>
	);
};
